export default __webpack_public_path__ + "static/media/Monk's Boots of the Hallow Worlds.ad9618cf.jpg";